<template>
    <div class="need">
        <div class="need-content">
            <h2>定制需求</h2>
            <form action="https://guanwang.wsandos.com/home/index/getNeed" method="post" target="submitFrame">
                <div>
                    <div ref="need">一句话描述您的需求，例如：房地产销售</div>
                    <input type="text" placeholder="一句话描述您的需求，例如：房地产销售" @focus="showneed" @input="valLength" ref="needinput"  name="demand">
                    <div class="count">{{count}}/20</div>
                </div>
                <div>
                    <div ref="phone">请输入您的手机号码</div>
                    <input type="text" placeholder="请输入您的手机号码" @focus="showphone" @change="checkPhone" ref="phoneinput" name="phone">
                </div>
                <button @click="send">发送</button>
            </form>
            <iframe  id="submitFrame" style="display: none;width:0; height:0" name="submitFrame"  src="about:blank"></iframe>
        </div>
    </div>
</template>

<script>
export default {
    name: "Need",
    data () {
        return {
            count: 0,
            phone: false
        }
    },
    methods: {
        valLength () {
            const needStr = this.$refs.needinput.value
            this.$refs.needinput.value = needStr.replace(/\s{2,}/g,' ')
            this.count = needStr.replace(/\s{1,}/g,'').length
            if( this.count > 20 ){
                this.count = 20
                this.$refs.needinput.value = needStr.substr( 0 , needStr.length - 1 )
            }
        },
        checkPhone () { 
            var phone = this.$refs.phoneinput.value;
            if(!(/^1[3456789]\d{9}$/.test(phone))){ 
                this.phone = false;
            }else{
                this.phone = true;
            }
        },
        send () {
            if(this.$refs.needinput.value.replace(/\s{1,}/g,'') ==''){
                alert("请填写内容！")
                event.preventDefault()
                return false
            }
            if(this.$refs.needinput.value.replace(/\s{1,}/g,'').length > 20){
                alert("超出20个字数限制！")
                event.preventDefault()
                this.$refs.needinput.value = ""
                this.count = 0
                return false
            }
            if(!this.phone){
                alert("手机号码有误，请重填");
                event.preventDefault()
                this.$refs.phoneinput.value = ""
                return false
            }
            alert("提交成功")
            this.count = 0
            setTimeout(()=>{
                this.$refs.needinput.value = ""
                this.$refs.phoneinput.value = ""
            },20)
        },
        showneed () {
            this.$refs.needinput.placeholder = ""
            this.$refs.need.style.color = "#999"
        },
        showphone () {
            this.$refs.phoneinput.placeholder = ""
            this.$refs.phone.style.color = "#999"
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/varible.styl'
     .need
        position: relative
        background: #f6f6f6
        .need-content
            width: 100%
            box-sizing: border-box
            padding: 1.14rem 4% 1.64rem
            h2
                text-align: center
                color: #333
                font-size: 0.4rem
                font-weight: 800
                letter-spacing: 1px
                margin-bottom: 0.68rem
            form
                >div
                    position: relative
                    width: 100%
                    color: #999
                    font-size: 0.26rem
                    >div:first-of-type
                        color: #f6f6f6
                        font-size: 0.24rem
                    input
                        width: 100%
                        line-height: 2.6em
                        color: $black
                        border: none
                        outline: none
                        border-bottom: 1px solid #888
                        background: #f6f6f6
                        font-weight: 400
                        margin-bottom: 1.4em
                    input:focus
                        border-bottom-color: #000
                    .count
                        position: absolute
                        right: 0
                        top: 50%
                        margin-top: -0.6em
                button
                    margin-top: 0.36rem
                    width: 100%
                    padding: 0.26rem 0
                    background: $yellow
                    color: #333
                    font-weight: 800
                    font-size: 0.28rem
                    line-height: 1em
                    outline: none
                    border: none
</style>


// WEBPACK FOOTER //
// src/components/mobile/ContactNeed.vue